import { branch, renderNothing } from 'recompose'

import { AppStoreBadge, GooglePlayStoreBadge } from '../AppDownloadBadge'
import PhonePictureCanada from '../../assets/app-canada.png'
import PhonePictureEurope from '../../assets/app-europe.png'
import featureToggles from 'shared/featureToggles'
import { countryFromHost } from 'shared/country'
import './styles.scss'

const DownloadApp = () => (
    <div className="download-app">
        <div className="download-app__bg">
            <div className="download-app__inner-container">
                <div className="download-app__content">
                    <h4>
                        <T>download.app.today.title</T>
                    </h4>
                    <div className="download-app__logos">
                        <AppStoreBadge />
                        <GooglePlayStoreBadge />
                    </div>
                </div>
                <div className="download-app__phone">
                    <img src={countryFromHost() === 'ca' ? PhonePictureCanada : PhonePictureEurope} />
                </div>
            </div>
            <div className="download-app__white-box" />
        </div>
    </div>
)

export default compose(branch(() => !featureToggles.showDownloadApp, renderNothing))(DownloadApp)
